import React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { logout, setLocale } from "../../store/actions";
import { decodeUserSession } from "../../utils/utils";
import ForbiddenPage from "./ForbiddenPage";
import { useAuth } from "react-oidc-context";

const Forbidden = (props) => {
    const { user } = props;
    const auth = useAuth();
    let userInformation = decodeUserSession(user);

    if (!userInformation && !auth.isAuthenticated && !auth.isLoading) {
        return <Redirect to={"/login"} push />;
    }

    return <ForbiddenPage />;
};

export default connect(
    ({ user, fetch }) => ({
        user,
        fetch,
    }),
    {
        logout,
        setLocale,
    },
)(Forbidden);
